<template>
	<div class="fill-height mt-3">
		<v-row align="center" class="justify-between">
			<v-card
				:width="$vuetify.breakpoint.width - 100"
				:style="!$vuetify.theme.dark ? 'box-shadow: -4px 3px 37px -3px #e8e7e76e' : null"
				class="rounded-lg fill-height pt-0"
			>	
				<v-card-text :height="$vuetify.breakpoint.height - 200" class="pt-0 px-0">
					<v-tabs  v-model="tab" show-arrows height="35" active-class="secondary-bg">
                        <v-tab 
                            class="text-none text-capitalize rounded-tl"
                            :to="{ 
                                name: 'task-papers',
                            }"
                        >
                            Tasks 
                        </v-tab>

						<v-tab 
                            class="text-none text-capitalize"
                            :to="{ 
                                name: 'task-matching',
                            }"
                        >
                            Validate 
                        </v-tab>
                    </v-tabs>
                    <v-divider v-if="!$route.query.preview" class="mb-2"/>

                    <!-- child page -->
                    <!-- <loader v-if="loading"/> -->
                    <router-view class="px-4"/>
				</v-card-text>
			</v-card>
		</v-row>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
	data () {
		return {
			tab: null
		}
	}
}
</script>

<style scoped>
.w-100 {
	width: 100%;
}
.secondary-bg {
	background-color: #FBF4DA
}
</style>
<style>
label.v-label.theme--light {
	color: black !important
}
</style>
